/** @format */

import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: (resolve) => require(['@/views/home'], resolve),
	},
]

const router = new VueRouter({
	mode: 'hash',
	routes,
})

export default router
